import app from '../../public-api';
import {Timer} from './Timer';
import {ViewportStateMonitor} from './ViewportStateMonitor';
import {trackerFactory} from './ViewTracker';
import {ViewportSyncronizer} from './ViewportSyncronizer';
import {ManualSyncService} from './ManualSyncService';
import {createButton} from './toolbar-button-helper';

app.plugins.register({
  name: 'us:manual-sync',

  extends: 'uScope',

  constructor: function (uScope) {
    const eventChannel = uScope.events.$new();
    const monitor = new ViewportStateMonitor(uScope);
    const synchronizer = new ViewportSyncronizer(uScope, trackerFactory);
    const timer = new Timer(monitor, synchronizer);
    const service = new ManualSyncService(eventChannel, monitor, synchronizer, timer);
    const button = createButton(eventChannel, () => {
      service.toggle();
    });

    // Start the sync service.
    service.init(uScope);

    uScope.topToolbar.addButton(button);
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/manual-sync/manual-sync-loader.js